import React from "react";
import {Link} from "gatsby";
import {theme} from "../../styles/theme";
import styled from "styled-components";


const SeeMore = ({link, text, isOnTile}) => {

    return (
        <>
            <StyledLink to={link} isOnTile={isOnTile}>
                {text}
                <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M12.2203 0.968997C12.29 0.899153 12.3728 0.843738 12.4639 0.805928C12.555 0.768119 12.6527 0.748657 12.7513 0.748657C12.85 0.748657 12.9477 0.768119 13.0388 0.805928C13.1299 0.843738 13.2127 0.899153 13.2823 0.968997L17.7823 5.469C17.8522 5.53867 17.9076 5.62143 17.9454 5.71255C17.9832 5.80366 18.0027 5.90135 18.0027 6C18.0027 6.09865 17.9832 6.19633 17.9454 6.28745C17.9076 6.37856 17.8522 6.46133 17.7823 6.531L13.2823 11.031C13.1415 11.1718 12.9505 11.2509 12.7513 11.2509C12.5522 11.2509 12.3612 11.1718 12.2203 11.031C12.0795 10.8902 12.0004 10.6992 12.0004 10.5C12.0004 10.3008 12.0795 10.1098 12.2203 9.969L16.1908 6L12.2203 2.031C12.1505 1.96133 12.0951 1.87857 12.0573 1.78745C12.0195 1.69633 12 1.59865 12 1.5C12 1.40135 12.0195 1.30366 12.0573 1.21255C12.0951 1.12143 12.1505 1.03867 12.2203 0.968997Z" fill="#E52F42"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 6C0 5.80109 0.0790178 5.61032 0.21967 5.46967C0.360322 5.32902 0.551088 5.25 0.75 5.25L16.5 5.25C16.6989 5.25 16.8897 5.32902 17.0303 5.46967C17.171 5.61032 17.25 5.80109 17.25 6C17.25 6.19891 17.171 6.38968 17.0303 6.53033C16.8897 6.67098 16.6989 6.75 16.5 6.75L0.75 6.75C0.551088 6.75 0.360322 6.67098 0.21967 6.53033C0.0790178 6.38968 0 6.19891 0 6Z" fill="#E52F42"/>
                </svg>
            </StyledLink>

        </>
    )
}

const StyledLink = styled(Link)`
  margin-top: ${props => !props.isOnTile ? '40px' : '10px' };
  color: ${theme.colors.red};
  font-size: 16px;

  svg {
    margin-left: 8px;
    transition: all .3s ease;
  }
  &:hover {
    svg {
      transform: translateX(8px);
    }
  }
`
export default SeeMore